import type { PublicProps as Props } from './types'

import { useEditing } from './hooks/useEditing'
import { PreferencesView } from './PreferencesView'
import { PreferencesForm } from './PreferencesForm'

export function Preferences(props: Props) {
  const { notificationPreferences, supportedLanguages, setEditingState, inEditing } = props
  const { onEdit } = useEditing(setEditingState)

  switch (inEditing) {
    case true:
      return (
        <PreferencesForm
          formValues={notificationPreferences}
          supportedLanguages={supportedLanguages}
        />
      )
    case false:
      return (
        <PreferencesView
          onEdit={onEdit}
          formValues={notificationPreferences}
          supportedLanguages={supportedLanguages}
        />
      )
  }
}
